export const ORGANIZATIONS_RESET_STATE = 'ORGANIZATIONS_RESET_STATE';
export const ORGANIZATIONS_CURRENT_ITEM = 'ORGANIZATIONS_CURRENT_ITEM';

export const ORGANIZATIONS_REQUEST_LOADING = 'ORGANIZATIONS_REQUEST_LOADING';
export const ORGANIZATIONS_REQUEST_SUCCESS = 'ORGANIZATIONS_REQUEST_SUCCESS';
export const ORGANIZATIONS_REQUEST_FAILED = 'ORGANIZATIONS_REQUEST_FAILED';

export const ORGANIZATIONS_CURRENT_ACTION = 'ORGANIZATIONS_CURRENT_ACTION';
export const ORGANIZATIONS_RESET_ACTION = 'ORGANIZATIONS_RESET_ACTION';